import JsCookie from "js-cookie";
const defaultCookiesToKeep = [
    /_ga/ // Google analytics
];
export const keepCookie = (key) => {
    return defaultCookiesToKeep.some(regex => regex.test(key));
};
export function removePasCookies() {
    Object.keys(JsCookie.get()).forEach(key => {
        if (!keepCookie(key)) {
            JsCookie.remove(key);
        }
    });
}
//# sourceMappingURL=cookieUtils.js.map